const SET_LOADING_PROGRESS_BAR = 'SET_LOADING_PROGRESS_BAR'

const _state = {
  loadingProgressBar: 0,
}

const _getters = {
  loadingProgressBar(state) {
    return state.loadingProgressBar
  },
}

const actions = {
  incrementProgressBarAction({ commit }) {
    commit(SET_LOADING_PROGRESS_BAR, 1)
  },
}

const mutations = {
  [SET_LOADING_PROGRESS_BAR](state, value) {
    state.loadingProgressBar += value
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}
